import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 5,
};

const unitConvertionHistorySlice = createSlice({
  name: "unitConvertionHistory",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    resetAll: (state) => {
      state.page = 1;
      state.limit = 5;
    },
  },
});

export const { setPage, setLimit, resetAll } = unitConvertionHistorySlice.actions;
export default unitConvertionHistorySlice.reducer;
